import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogProps,
  TextField,
  Button,
  Box
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CodeInput from './CodeInput'

export interface PinCodeDialogProps extends Omit<DialogProps, 'children' | 'onSubmit' | 'onClose'> {
  onSubmit: (pin: number) => Promise<void>
  onClose: () => void
}

export default function PinCodeDialog({ open, onSubmit, onClose, ...props }: PinCodeDialogProps) {
  const { t } = useTranslation()

  const [pin, setPin] = useState<string>('')

  const isValid = pin.length === 4 && !Number.isNaN(Number(pin))

  const handleChange = (code: string) => {
    setPin(code)
  }

  const handleSubmit = () => {
    if (isValid) {
      onSubmit(Number(pin))
    }
  }

  useEffect(() => {
    if (!open) {
      setPin('')
    }
  }, [open])

  return (
    <Dialog maxWidth="xs" fullWidth open={open} {...props}>
      <DialogTitle>{t('enterPin')}</DialogTitle>
      <DialogContent>
        <CodeInput
          value={pin?.toString() || undefined}
          onChange={handleChange}
          length={4}
          sx={{ mt: 2 }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{t('actions:cancel')}</Button>
        <Button variant="contained" disabled={!isValid} onClick={handleSubmit}>
          {t('actions:confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
